import { Injectable } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";

import { globalVariables } from "src/app/core/constants/globalVariables";
import { CommonModel } from "../models/common-model";

import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { DataLoadService } from "./data-load.service";
const coreUrl = globalVariables.ERP_URL.adminApiUrl + "core/file/";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
@Injectable({
  providedIn: "root",
})
export class UtilityService {
  constructor(
    private router: Router,
    public dataLoadService: DataLoadService,
    public toastr: ToastrService,
    private dialog: MatDialog
  ) {}

  public getEnumList(enumEntity): any {
    const enumList: CommonModel[] = [];
    for (const prop in enumEntity) {
      const comObj = new CommonModel();
      comObj.VALUE = enumEntity[prop];
      comObj.TEXT =
        prop.toUpperCase() === prop ? prop : this.spaceWithCamel(prop);
      enumList.push(comObj);

      // let isValueProperty = parseInt(enumMember) >= 0;
      // if (!isValueProperty) {
      //     let newObject = new DdlModel();
      //     newObject.VALUE = myEnum[enumMember];
      //     newObject.TEXT = this.spaceWithCamel(enumMember);
      //     enumList.push(newObject);
      // }
    }
    return enumList;
  }

  // showReport
  public showReport(params, f?: any): void {
    let counter = 1;
    let report_url = "";
    for (var param in params) {
      // console.log(params[param], 'report_url');
      if (counter <= 2) {
        report_url += params[param];
        counter++;
      } else {
        report_url += "&" + param + "=" + params[param];
        counter++;
      }
    }

    // let uri=encodeURI(report_url)
    // console.log(uri);
    //const win = window.open(report_url, '_blank');
    // Open with new window
    const win = window.open(report_url, "_blank");
    if (win) {
      // Browser has allowed it to be opened
      win.focus();
    } else {
      // Browser has blocked it
      alert("Please allow popups for this website");
    }
  }

  public showReportJasp(reportUrl): void {
    // Open with new window
    const win = window.open(reportUrl, "_blank");
    if (win) {
      // Browser has allowed it to be opened
      win.focus();
    } else {
      // Browser has blocked it
      alert("Please allow popups for this website");
    }
  }

  /*private methods*/
  private spaceWithCamel(text): any {
    return (
      text
        // insert a space before all caps
        .replace(/([A-Z])/g, " $1")
        // uppercase the first character
        .replace(/^./, function (str) {
          return str.trim();
        })
    );
  }

  //Compare Objects
  public psHasAnyChange(a: any, b: any) {
    const a_string = typeof a === "object" ? JSON.stringify(a) : a;
    const b_string = typeof b === "object" ? JSON.stringify(b) : b;
    return a_string !== b_string;
  }

  // public getDateFormat(date: any, format: any) {
  //     return this.datePipe.transform(date, format);
  // }

  public async psForkJoin(promiseList: Observable<any>[]) {
    let results = [];
    for (let index = 0; index < promiseList.length; index++) {
      const element = promiseList[index];
      try {
        results[index] = await element.toPromise();
      } catch (error) {
        console.log("Error", error);
      }
    }
    return results;
  }

  public openIntForm(url: string, sKey?: string, sParams?: any) {
    sessionStorage.setItem(sKey, JSON.stringify(sParams));
    var cPath = window.location.pathname;
    console.log(cPath);
    window.open(window.location.origin + cPath + "#" + url, "_blank");
  }

  public getExtras(router: Router, sKey: any) {
    let _navigation = this.router.getCurrentNavigation();

    if (_navigation != null && _navigation?.extras?.state) {
      return _navigation;
    } else {
      let tmpVal = sessionStorage.getItem(sKey);
      console.log("tmpVal:" + tmpVal);

      if (!tmpVal) {
        // if null
        return this.router.getCurrentNavigation();
      }

      let obj = { replaceUrl: true };
      obj = JSON.parse(tmpVal);
      // obj = Object.assign(obj);
      obj = Object.assign(obj, { replaceUrl: true });
      console.log("obj", obj);

      // let extras: NavigationExtras;
      // extras = obj;

      let navigation = {
        extras: JSON.parse(tmpVal),
      };

      console.log({ navigation });

      // let navigation = this.router.getCurrentNavigation();
      // navigation.extras = extras;

      sessionStorage.removeItem(sKey);

      return navigation;
    }
  }
  //add days with date
  public addDays(_date: Date, nDay: any) {
    let newDate = new Date();
    var days = _date.getDate();

    newDate.setDate(_date.getDate());
    newDate.setMonth(_date.getMonth());
    newDate.setFullYear(_date.getFullYear());

    days += Number(nDay + "");
    newDate.setDate(days);

    return newDate;
  }

  public domExcel(res: any, fname: string) {
    var blob = new Blob([res]);
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fname.split(" ").join("_");
    link.click();
  }

  public hasRecord(result: any) {
    let st = false;
    if (result.body) {
      return (st = true);
    } else {
      this.toastr.warning("No record found", "Warning");
      return (st = false);
    }
  }

  public checkResp(result: any) {
    let st = false;
    if (result.status == globalVariables.respStatus200) {
      return (st = true);
    } else {
      this.toastr.error(result.message, "Error");
      return (st = false);
    }
  }

  public getPageSize() {
    let pageSize = localStorage.getItem("pageSize");
    return pageSize;
  }

  public openDialog(componentName, modalSizeClss = "modal-sm", data: any = {}) {
    // console.log(data)
    if (!modalSizeClss.includes("modal-")) {
      let modalSizeClssUpdate = "modal-" + modalSizeClss;
      modalSizeClss = modalSizeClssUpdate;
    }
    const config = new MatDialogConfig();
    config.hasBackdrop = false;
    config.panelClass = modalSizeClss;
    if (Object.keys(data).length === 0 && data.constructor === Object) {
      data.title = "New Dialog";
    }
    config.data = JSON.parse(JSON.stringify(data));
    const dialogRef = this.dialog.open(componentName, config);
    return dialogRef.afterClosed();
    // .subscribe(result => {
    //   console.log({ result });
    //   // this.animal = result;
    // });
  }

  // convert comma separated string to number
  convertCommaSeparatedStringTonumber(str) {
    // console.log(typeof str)
    let num;
    if (str) {
      if (str.toString().includes(",")) {
        num = parseFloat(str.replaceAll(",", ""));
      } else {
        num = parseFloat(str);
      }
      //   console.log(num)
      return num;
    }
  }

  currncyFormat: any =
    JSON.parse(localStorage.getItem("currencyFormat")) || null;
  numberFormat: any = JSON.parse(localStorage.getItem("numberFormat")) || null;

  getCurrencyFormat(currency) {
    // console.log({currency})
    return new Intl.NumberFormat(this.currncyFormat?.LOCAL_CURRNCY_TAG, {
      currency: this.currncyFormat?.LOCAL_CURRNCY_NAME,
    }).format(currency);
  }

  getNumberFormat(number) {
    let dec = this.numberFormat?.maxAmt.toString().split(",")[1];
    let num = Number(
      new Intl.NumberFormat(this.numberFormat?.numFormat).format(number)
    );
    //     let num = Number(new Intl.NumberFormat(this.currncyFormat?.LOCAL_CURRNCY_TAG, { currency: this.currncyFormat?.LOCAL_CURRNCY_NAME }).format(
    //      number,
    //    ))
    //  console.log({num})
    return num.toFixed(dec);
  }

  applySameWidthToAllButtonElements(buttons) {
    // Get all button elements
    const buttonElements = buttons.map((button) => button.nativeElement);

    // Calculate the maximum width
    let maxWidth = 0;
    buttonElements.forEach((button) => {
      const buttonWidth = button.offsetWidth;
      if (buttonWidth > maxWidth) {
        maxWidth = buttonWidth;
      }
    });

    // Apply the maximum width to all buttons
    buttonElements.forEach((button) => {
      button.style.width = `${maxWidth}px`;
    });
  }
}
